var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeoissue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_3546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1729 6.27857V4.00253",
    stroke: "white",
    strokeWidth: 0.983334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8086 1.72654C14.747 1.61137 14.6555 1.51507 14.5435 1.44792C14.4315 1.38077 14.3034 1.34531 14.1728 1.34531C14.0422 1.34531 13.9142 1.38077 13.8022 1.44792C13.6902 1.51507 13.5986 1.61137 13.537 1.72654L9.70113 9.03641C9.64446 9.14407 9.61684 9.2647 9.62102 9.38624C9.62511 9.50785 9.66085 9.62628 9.72465 9.72984C9.78929 9.83401 9.8795 9.91989 9.98663 9.97937C10.0938 10.0389 10.2144 10.07 10.3369 10.0697H18.0087C18.1313 10.07 18.2518 10.0389 18.359 9.97937C18.4662 9.91989 18.5563 9.83401 18.6209 9.72984C18.6847 9.62628 18.7205 9.50785 18.7247 9.38624C18.7287 9.2647 18.7011 9.14407 18.6445 9.03641L14.8086 1.72654Z",
    stroke: "white",
    strokeWidth: 0.983334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 13.414H17.2077",
    stroke: "white",
    strokeWidth: 0.983334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2077 11.5173V14.9314C17.2077 15.1326 17.1277 15.3256 16.9855 15.4679C16.8432 15.6101 16.6502 15.6901 16.449 15.6901H2.03407C1.83285 15.6901 1.63988 15.6101 1.4976 15.4679C1.35532 15.3256 1.27539 15.1326 1.27539 14.9314V5.06856C1.27539 4.86734 1.35532 4.67437 1.4976 4.53209C1.63988 4.38981 1.83285 4.30988 2.03407 4.30988H8.8622",
    stroke: "white",
    strokeWidth: 0.983334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96533 18.7249C7.65256 17.8571 8.05056 16.7958 8.10335 15.6902",
    stroke: "white",
    strokeWidth: 0.983334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5174 18.7249C10.8302 17.8571 10.4322 16.7958 10.3794 15.6902",
    stroke: "white",
    strokeWidth: 0.983334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82715 18.7248H12.6553",
    stroke: "white",
    strokeWidth: 0.983334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1726 8.17539C14.0678 8.17539 13.9829 8.09047 13.9829 7.98572C13.9829 7.88097 14.0678 7.79605 14.1726 7.79605",
    stroke: "white",
    strokeWidth: 0.983334
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1729 8.17539C14.2776 8.17539 14.3625 8.09047 14.3625 7.98572C14.3625 7.88097 14.2776 7.79605 14.1729 7.79605",
    stroke: "white",
    strokeWidth: 0.983334
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_3546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoissue);
export default __webpack_public_path__ + "static/media/seoissue.0487eae129dc4d216cb757e76e04b0fd.svg";
export { ForwardRef as ReactComponent };